var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgeRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0532 8.77148V13.2273L16.5557 15.3622",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20703 9.7435C6.5841 5.84989 10.5304 3.48116 14.6142 4.09696C18.698 4.71277 21.7704 8.13987 21.9381 12.2664C22.1057 16.393 19.3216 20.0581 15.3012 21.0032",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9995 22.0042H4.49679C4.22053 22.0042 3.99658 21.7802 3.99658 21.504V21.0978C3.99988 19.9422 4.93586 19.0062 6.09145 19.0029H9.40483C10.5604 19.0062 11.4964 19.9422 11.4997 21.0978V21.504C11.4997 21.7802 11.2758 22.0042 10.9995 22.0042Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74789 16.5017C6.6439 16.5017 5.74854 15.6075 5.74707 14.5035C5.74561 13.3995 6.63859 12.503 7.74258 12.5C8.84656 12.4971 9.74431 13.3889 9.74874 14.4928C9.75085 15.0249 9.54099 15.5359 9.16553 15.9128C8.79007 16.2898 8.27993 16.5017 7.74789 16.5017Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeRange);
export default __webpack_public_path__ + "static/media/age-range.9744d79f.svg";
export { ForwardRef as ReactComponent };